import { render, staticRenderFns } from "./DxpPageHeader.vue?vue&type=template&id=4b75f85e&scoped=true"
import script from "./DxpPageHeader.vue?vue&type=script&lang=js"
export * from "./DxpPageHeader.vue?vue&type=script&lang=js"
import style0 from "./DxpPageHeader.vue?vue&type=style&index=0&id=4b75f85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b75f85e",
  null
  
)

export default component.exports